import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { PackingParcelWithTransportPlanChoiceDto } from '@/types/PackingParcel';

const ENDPOINT = `${APIConfiguration.carrier}packing/create`;

export interface CreatePackingCommandPayload {
  sellerId: string;
  waitingPackingProductIds: string[];
}

async function createPackingCommand(
  payload: CreatePackingCommandPayload,
): Promise<
  BackResponse<PackingParcelWithTransportPlanChoiceDto> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<PackingParcelWithTransportPlanChoiceDto>>(
      ENDPOINT,
      {
        method: SUPPORTED_METHODS.POST,
        json: payload,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default createPackingCommand;
